/**
 * Embla Carousel Entrypoint
 * Bundles EmblaCarousel with plugins for Shopify theme
 */
import EmblaCarousel from 'embla-carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

export { EmblaCarousel, AutoScroll, WheelGesturesPlugin };

if (typeof window !== 'undefined') {
  (window as any).EmblaCarousel = EmblaCarousel;
  (window as any).EmblaAutoScroll = AutoScroll;
  (window as any).EmblaWheelGestures = WheelGesturesPlugin;
}

